export const MERGE_FUEL_ECONOMY_FROM_API = 'MERGE_FUEL_ECONOMY_FROM_API';
export const APPLY_FUEL_SAVING_CDL = 'APPLY_FUEL_SAVING_CDL';
export const APPLY_AND_PRINT_FUEL_SAVING_CDL = 'APPLY_AND_PRINT_FUEL_SAVING_CDL';
